import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { theme } from "../styles/theme";
import { Business } from "@mui/icons-material";
import logo from "../assets/amplelark.png";

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: all 0.3s ease;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
`;

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
`;

const LogoText = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: ${theme.colors.primary};
  display: flex;
  align-items: center;

  span {
    color: ${theme.colors.secondary};
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    display: none;
  }
`;

const LogoIcon = styled.div`
  display: none;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.white};
  font-weight: 700;
  font-size: 1.2rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: ${theme.breakpoints.tablet}) {
    display: flex;
  }

  svg {
    font-size: 1.5rem;
  }
`;

const MenuToggle = styled.button`
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;

  span {
    width: 30px;
    height: 3px;
    background: ${theme.colors.primary};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    display: flex;
  }
`;

const NavMenu = styled.ul`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: ${theme.breakpoints.tablet}) {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: 300px;
    background-color: ${theme.colors.white};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
    transition: transform 0.3s ease-in-out;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
  }
`;

const NavItem = styled.li`
  a {
    font-weight: 500;
    color: ${theme.colors.dark};
    position: relative;
    transition: color 0.3s ease;

    &:hover {
      color: ${theme.colors.primary};
    }

    &::after {
      content: "";
      position: absolute;
      width: 0;
      height: 2px;
      bottom: -5px;
      left: 0;
      background-color: ${theme.colors.primary};
      transition: width 0.3s ease;
    }

    &:hover::after {
      width: 100%;
    }
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    margin: 1rem 0;
    font-size: 1.2rem;
  }
`;

const CTAButton = styled(Link)`
  background: linear-gradient(
    135deg,
    ${theme.colors.primary},
    ${theme.colors.secondary}
  );
  color: ${theme.colors.white};
  padding: 0.7rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 119, 182, 0.3);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 119, 182, 0.4);
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    margin-top: 1rem;
  }
`;

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <HeaderContainer>
      <div className="container">
        <Nav>
          <LogoContainer to="/">
            <LogoIcon>
              <img src={logo} alt="AmpleLark Logo" style={{ width: '24px', height: '24px' }} />
            </LogoIcon>
            <LogoText>
              Ample<span>Lark</span> Technologies
            </LogoText>
          </LogoContainer>
          <MenuToggle open={isOpen} onClick={() => setIsOpen(!isOpen)}>
            <span />
            <span />
            <span />
          </MenuToggle>
          <NavMenu open={isOpen}>
            <NavItem>
              <Link to="/" onClick={() => setIsOpen(false)}>
                Home
              </Link>
            </NavItem>
            <NavItem>
              <a href="#features" onClick={() => setIsOpen(false)}>
                Features
              </a>
            </NavItem>
            <NavItem>
              <a href="#apps" onClick={() => setIsOpen(false)}>
                Our Apps
              </a>
            </NavItem>
            <NavItem>
              <a href="#future" onClick={() => setIsOpen(false)}>
                Future
              </a>
            </NavItem>
            <NavItem>
              <Link to="/contact" onClick={() => setIsOpen(false)}>
                Contact
              </Link>
            </NavItem>
            <CTAButton to="/contact" onClick={() => setIsOpen(false)}>
              Get In Touch
            </CTAButton>
          </NavMenu>
        </Nav>
      </div>
    </HeaderContainer>
  );
};

export default Header;